export default __webpack_public_path__ + "static/media/50.cccd1d52.png";